export enum ReviewStatusEnum {
    Pending = "Pending",
    InProgress = "InProgress",
    Performed = "Performed",
    Completed = "Completed"
}